import Vue from 'vue';
import Vuex from 'vuex';
import state from './rootState';
import mutations from './rootMutations';
import actions from './rootActions';
import getters from './rootGetters';
import * as auth from './modules/auth';
import * as rbac from './modules/rbac';
import * as globalFlags from './modules/globalFlags';
import * as status from './modules/status';
import * as announcements from './modules/announcements';
import * as user from './modules/user';
import * as password from './modules/password';
import * as personal from './modules/personal';
import * as userClients from './modules/userClients';
import * as identityProviders from './modules/identityProviders';
import * as mfa from './modules/mfa';
import * as reports from './modules/reports';
import * as reports_v2 from './modules/reports_v2';
import * as costForecast from './modules/costForecast';
import * as budget from './modules/budget';
import * as accounts from './modules/accounts';
import * as crossTags from './modules/crossTags';
import * as groups from './modules/groups';
import * as billingReports from './modules/billingReports';
import * as notificationSettings from './modules/notificationSettings';
import * as devTools from './modules/devTools';
import * as dashboard from './modules/dashboard';
import * as usageReports from './modules/usageReports';
import * as reportFilters from './modules/reportFilters';
import * as actionsObserver from './modules/actionsObserver';

Vue.use(Vuex);

const vuex = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    auth: { namespaced: true, ...auth },
    rbac: { namespaced: true, ...rbac },
    globalFlags: { namespaced: true, ...globalFlags },
    status: { namespaced: true, ...status },
    announcements: { namespaced: true, ...announcements },
    user: { namespaced: true, ...user },
    password: { namespaced: true, ...password },
    personal: { namespaced: true, ...personal },
    userClients: { namespaced: true, ...userClients },
    identityProviders: { namespaced: true, ...identityProviders },
    mfa: { namespaced: true, ...mfa },
    reports: { namespaced: true, ...reports },
    reports_v2: { namespaced: true, ...reports_v2 },
    costForecast: { namespaced: true, ...costForecast },
    budget: { namespaced: true, ...budget },
    accounts: { namespaced: true, ...accounts },
    crossTags: { namespaced: true, ...crossTags },
    groups: { namespaced: true, ...groups },
    billingReports: { namespaced: true, ...billingReports },
    notificationSettings: { namespaced: true, ...notificationSettings },
    devTools: { namespaced: true, ...devTools },
    dashboard: { namespaced: true, ...dashboard },
    usageReports: { namespaced: true, ...usageReports },
    reportFilters: { namespaced: true, ...reportFilters },
    actionsObserver: { namespaced: true, ...actionsObserver },
  },
});
export default vuex;
